<script setup lang="ts">
import { VBtn, VMenu } from 'vuetify/components';
import { BIcon, BList } from '@/design-system';
import type { VList } from 'vuetify/components';

withDefaults(
    defineProps<{
        modelValue?: boolean;
        location?: VMenu['$props']['location'];
        closeOnContentClick?: boolean;
        activatorBtnSize?: string;
        activatorBtnClasses?: string;
        activatorBtnColor?: string;
        activatorBtnDensity?: VBtn['$props']['density'];
        activatorBtnElevation?: string;
        activatorBtnDisabled?: boolean;
        activatorBtnAbsolute?: boolean;
        activatorBtnOffsetY?: boolean;
        activatorBtnOffsetX?: boolean;
        activatorBtnIsIcon?: boolean;
        activatorBtnRounded?: VBtn['$props']['rounded'];
        activatorBtnVariant?: VBtn['$props']['variant'];
        activatorIcon?: string;
        activatorIconClr?: string;
        activatorIconSize?: string;
        activatorIconClasses?: string;
        listClasses?: string;
        listDensity?: VList['$props']['density'];
    }>(),
    {
        modelValue: undefined,
        location: 'bottom',
        closeOnContentClick: true,
        activatorBtnDensity: 'compact',
        activatorBtnIsIcon: true,
        activatorBtnVariant: 'text',
        activatorIcon: 'mdi-dots-vertical',
        listDensity: 'compact',
        activatorBtnRounded: false,
    },
);

const emit = defineEmits<{
    'update:modelValue': [value: boolean];
}>();
</script>

<template>
    <VMenu
        v-bind="modelValue !== undefined ? { modelValue } : {}"
        :location="location"
        :close-on-content-click="closeOnContentClick"
        @update:model-value="emit('update:modelValue', $event)"
    >
        <template #activator="{ props: activatorProps }">
            <slot
                name="activator"
                :props="activatorProps"
            >
                <VBtn
                    v-bind="activatorProps"
                    :class="activatorBtnClasses"
                    :color="activatorBtnColor"
                    :elevation="activatorBtnElevation"
                    :absolute="activatorBtnAbsolute"
                    :offset-y="activatorBtnOffsetY"
                    :offset-x="activatorBtnOffsetX"
                    :icon="activatorBtnIsIcon"
                    :flat="activatorBtnIsIcon"
                    :density="activatorBtnDensity"
                    :size="activatorBtnSize"
                    :disabled="activatorBtnDisabled"
                    :variant="activatorBtnVariant"
                    :rounded="activatorBtnRounded"
                    @click.stop
                >
                    <BIcon
                        v-if="activatorIcon"
                        :class="activatorIconClasses"
                        :icon="activatorIcon"
                        :color="activatorIconClr"
                        :size="activatorIconSize"
                    />
                    <slot name="activator-content" />
                </VBtn>
            </slot>
        </template>

        <BList
            :class-list="listClasses"
            :density="listDensity"
        >
            <slot name="list-items" />
        </BList>
    </VMenu>
</template>

<style lang="scss" scoped>
.min-width-30px {
    min-width: 30px;
}
:deep(.header-dropdown-menu) {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}
</style>
